// @ts-nocheck

"use client"

import React from "react";
import CookieConsent from "react-cookie-consent";
import "./styles.scss";

const CookieBanner = () => {
    return (
        <CookieConsent
            location="bottom"
            buttonText="Accept"
            cookieName="BeLuxe_cookie"
            expires={150}
            buttonClasses="!bg-[#EBD29F] !border-[#EBD29F] !border-[0.5px] !text-white !rounded-lg uppercase hover:!bg-transparent duration-300 ease-in-out"
            containerClasses="!bg-[#2a3026] !text-white duration-300 ease-in-out max-w-full lg:max-w-[360px] lg:!right-3 lg:!bottom-3 lg:!left-[auto] fixed !z-[1050]"
            contentClasses="text-[14px]"
        >
            <strong>We use cookies.</strong> By using the site, you consent to the use of cookies, according to your current browser settings.
        </CookieConsent>
    )
}

export default CookieBanner